import React, { useRef } from "react";
import NavBar from "../NavBar";
import Banner from "../Banner";
import About from "../About";
import Technologies from "../Technologies";
import Experience from "../Experience";
import Project from "../Project";
import Contact from "../Contact";
import DownloadResume from "../DownloadResume";

const HomePage = () => {
  const aboutRef = useRef(null);
  const downloadResumeRef = useRef(null);
  const technologiesRef = useRef(null);
  const experienceRef = useRef(null);
  const projectRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (section) => {
    console.log("section", section);
    switch (section) {
      case "About":
        aboutRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "Resume":
        downloadResumeRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "Technologies":
        technologiesRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "Experience":
        experienceRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "Projects":
        projectRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "Contact":
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      default:
        break;
    }
  };

  return (
    <div className="container mx-auto px-8">
      <NavBar scrollToSection={scrollToSection} />
      <Banner />
      <div ref={aboutRef}>
        <About />
      </div>
      <div ref={downloadResumeRef}>
        <DownloadResume />
      </div>
      <div ref={technologiesRef}>
        <Technologies />
      </div>
      <div ref={experienceRef}>
        <Experience />
      </div>
      <div ref={projectRef}>
        <Project />
      </div>
      <div ref={contactRef}>
        <Contact />
      </div>
    </div>
  );
};

export default HomePage;
